import { render, staticRenderFns } from "./QuestionAdd.vue?vue&type=template&id=51efde76&"
import script from "./QuestionAdd.vue?vue&type=script&lang=ts&"
export * from "./QuestionAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51efde76')) {
      api.createRecord('51efde76', component.options)
    } else {
      api.reload('51efde76', component.options)
    }
    module.hot.accept("./QuestionAdd.vue?vue&type=template&id=51efde76&", function () {
      api.rerender('51efde76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questions/QuestionAdd.vue"
export default component.exports